import { FormControls } from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { detectionPeriodOptions } from 'shared/constants';
import { AddTestForm } from 'shared/types';

const anomalyDirectionMap: Record<string, string> = {
  DROP: 'only drops',
  SPIKE: 'only spikes',
  BOTH: 'spikes and drops',
};

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const getDetectionPeriodLabel = (unit: string): string => {
  const option = detectionPeriodOptions.find((opt) => opt.value === unit);
  return option?.label || unit;
};

const TablesVolumeAnomaliesCloudConfig = ({ watch }: Props) => {
  const anomalyDirection: 'BOTH' | 'DROP' | 'SPIKE' | undefined = watch(
    'anomalyConfig.anomalyDirection',
  );

  return (
    <>
      {watch('anomalyConfig.anomalyDirection') && (
        <FormControls.FormText>
          <span>{`Detect `}</span>{' '}
          <b>{anomalyDirectionMap[anomalyDirection!]}</b>
          <span>{` in the table's row count.`}</span>
        </FormControls.FormText>
      )}

      {watch('anomalyConfig.sensitivity') && (
        <FormControls.FormText>
          Set the sensitivity level to{' '}
          <b>{watch('anomalyConfig.sensitivity')}</b>.
        </FormControls.FormText>
      )}

      {watch('anomalyConfig.detectionPeriod') && (
        <FormControls.FormText>
          Anomalies during the last{' '}
          <b>
            {watch('anomalyConfig.detectionPeriod.count')}{' '}
            {getDetectionPeriodLabel(
              watch('anomalyConfig.detectionPeriod.period'),
            )}
          </b>{' '}
          will impact the test result. Rest of the time will be used as the
          training period.
        </FormControls.FormText>
      )}

      {watch('anomalyConfig.trainingPeriod') && (
        <FormControls.FormText>
          Training period:{' '}
          <b>
            {pluralizeString(
              watch('anomalyConfig.trainingPeriod.count') || 1,
              watch('anomalyConfig.trainingPeriod.period') || 'day',
              `${watch('anomalyConfig.trainingPeriod.period') || 'day'}s`,
            )}
          </b>
          .
        </FormControls.FormText>
      )}

      <SeverityRenderer severity={watch('severity')?.type || 'error'} />
    </>
  );
};

export default TablesVolumeAnomaliesCloudConfig;
